import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, ArrowRight } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Link } from "react-router-dom";
import { createPageUrl } from "../../utils";

export default function RecentTransactions({ lancamentos }) {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', { 
      style: 'currency', 
      currency: 'BRL' 
    }).format(value);
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden">
      <div className="p-6 border-b border-stone-100 flex items-center justify-between">
        <h3 className="font-bold text-lg text-stone-800">Últimos Lançamentos</h3>
        <Link 
          to={createPageUrl("Financeiro")}
          className="text-sm text-[#40916C] hover:text-[#2D6A4F] font-medium flex items-center gap-1"
        >
          Ver todos <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      
      <div className="divide-y divide-stone-100">
        {lancamentos.length === 0 ? (
          <div className="p-8 text-center text-stone-500">
            Nenhum lançamento registrado
          </div>
        ) : (
          lancamentos.slice(0, 5).map((lancamento, index) => (
            <motion.div
              key={lancamento.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="p-4 hover:bg-stone-50 transition-colors"
            >
              <div className="flex items-center gap-4">
                <div className={`p-2 rounded-xl ${
                  lancamento.tipo === 'receita' 
                    ? 'bg-green-100 text-green-600' 
                    : 'bg-red-100 text-red-600'
                }`}>
                  {lancamento.tipo === 'receita' 
                    ? <TrendingUp className="w-5 h-5" />
                    : <TrendingDown className="w-5 h-5" />
                  }
                </div>
                
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-stone-800 truncate">
                    {lancamento.descricao || lancamento.categoria}
                  </p>
                  <p className="text-sm text-stone-500">
                    {lancamento.categoria} • {format(new Date(lancamento.data), "dd MMM", { locale: ptBR })}
                  </p>
                </div>
                
                <p className={`font-bold ${
                  lancamento.tipo === 'receita' ? 'text-green-600' : 'text-red-600'
                }`}>
                  {lancamento.tipo === 'receita' ? '+' : '-'}{formatCurrency(lancamento.valor)}
                </p>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
}